import SplashScreen from "@/components/SplashScreen";
import useAuth from "@/hooks/useAuth";
import { FC, ReactNode, useEffect, useRef, useState } from "react";
import { getUserByToken } from "@/utils/api";
import { useNavigate } from "react-router-dom";

interface AuthProps {
  children: ReactNode;
}

const Auth: FC<AuthProps> = ({ children }) => {
  const { auth, logout, setUser, isTabletUser } = useAuth((state) => state);
  const navigate = useNavigate();
  const didRequest = useRef(false);
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const response = await getUserByToken();

          if (
            response &&
            response.payload &&
            response.payload.data.requireResetPassword && !isTabletUser
          ) {
            navigate("/auth/reset-password");
            return;
          }
          if (response && response.payload && response.payload.data) {
            setUser(response.payload.data);
          }
        }
      } catch (error) {
        console.warn(error);
        if (!didRequest.current) {
          logout();
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (auth && auth.token) {
      requestUser();
    } else {
      logout();
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <SplashScreen /> : <>{children}</>;
};

export default Auth;
